export const getDealerUrl = async () => {
  const response = await fetch('/config.json');
  if (!response.ok) {
    throw new Error(`Failed to fetch config: ${response.status}`);
  }
  const config = await response.json();
  return config.DealerUrl;
};







export const getUserurl = async () => {
  const response = await fetch('/config.json');
  if (!response.ok) {
    throw new Error(`Failed to fetch config: ${response.status}`);
  }
  const config = await response.json();
  return config.Userurl;
};



export const getbaseurlotp = async () => {
  const response = await fetch('/config.json');
  if (!response.ok) {
    throw new Error(`Failed to fetch config: ${response.status}`);
  }
  const config = await response.json();
  return config.baseurlotp;
};






  



